export function formatPrice(price: number) {
  return price && price.toFixed(2);
}
